<template>
  <span>
    <span class="pushbtn" @click="pushStatus = true">
      <img src="~assets/img/onlineblock/topnotefilled.png" />
      公告
    </span>
    <Modal class="editBlock" v-model="pushStatus" title="公告讯息" width="35" footer-hide>
      <div class="bodytwice">
        <div class="title">发送公告讯息</div>
        <div class="content">
          <Row>
            <Col span="12">
              <label>发送者</label>
              <Input
                v-if="username"
                class="editInput"
                v-model="username.nickname"
                type="text"
                disabled
              ></Input>
            </Col>
          </Row>
          <Row>
            <Col>
              <label>公告内容</label>
              <Input
                type="textarea"
                :autosize="{minRows: 4,maxRows: 7}"
                placeholder="公告内容"
                v-model="innertext"
              />
            </Col>
          </Row>
        </div>
      </div>
      <div class="modal-body-footer">
        <div class="btngp">
          <div class="btn" @click="pushConfirm">發送</div>
          <div class="btn" @click="cancel">取消</div>
        </div>
      </div>
    </Modal>
  </span>
</template>
<script>
import { mapGetters } from 'vuex'
export default {
  name: "ModalPush",
  data () {
    return {
      innertext: "",
      pushStatus: false
    }
  },
  computed: {
    ...mapGetters(['username', 'onlinestatus', 'fd']),
  },
  methods: {
    pushConfirm () {
      this.$axios.tpmsgreco({
        userid: Number(this.username.maid),
        innertext: this.innertext,
        servid: "0"
      })
        .then(res => { })
        .catch(err => console.error(err))

      if (this.onlinestatus) {
        this.$socket.sendObj({
          route: "tpmsg",
          sender: this.fd,
          sendmsg: this.innertext,
          maid: this.username.maid,
          nickname: this.username.nickname
        })
      }
      this.pushStatus = false
      this.innertext = ""

    },
    cancel () {
      this.pushStatus = false
      this.innertext = ""
    }
  }
}
</script>